import {
  ColumnMenu,
  ColumnOption
} from 'src/components/shared/DataGrid/ColumnMenu';
import { MixtureDto } from 'src/store/mixtures/mixture';
import { LocalStorage } from 'src/utils/localStorage';

export const MIXTURE_COLUMNS_KEY = 'mixture_columns';

const mixtureColumns: ColumnOption<MixtureDto>[] = [
  {
    title: 'props.number',
    field: 'no',
    disabled: true
  },
  {
    title: 'mixture.mixDate',
    field: 'mixDate',
    disabled: true
  },
  {
    title: 'props.status',
    field: 'mixtureStatusName'
  },
  {
    title: 'product.runNo',
    field: 'runNo'
  },
  {
    title: 'product.lotNo',
    field: 'lotNo'
  },
  {
    title: 'runSystem.singular',
    field: 'runSystemName'
  },
  {
    title: 'props.totalAmount',
    field: 'totalAmount'
  },
  {
    title: 'props.amount',
    field: 'currentAmount'
  },
  {
    title: 'props.totalCount',
    field: 'totalNumber'
  },
  {
    title: 'props.count',
    field: 'currentNumber'
  },
  {
    title: 'grade.singular',
    field: 'gradeName'
  },
  {
    title: 'specification.pspNo',
    field: 'specificationNo'
  },
  {
    title: 'specification.psp',
    field: 'specificationName'
  }
];

export const getMixtureColumns = (): ColumnOption<MixtureDto>[] =>
  LocalStorage.getItem(MIXTURE_COLUMNS_KEY) ?? mixtureColumns;

type MixturesListColumnMenuProps = {
  selectedColumns: ColumnOption<MixtureDto>[];
  onSelectedColumnsChange: (columns: ColumnOption<MixtureDto>[]) => void;
};

export function MixturesListColumnMenu({
  selectedColumns,
  onSelectedColumnsChange
}: MixturesListColumnMenuProps) {
  const onColumnsChange = (columns: ColumnOption<MixtureDto>[]) => {
    onSelectedColumnsChange(columns);
    LocalStorage.setItem(MIXTURE_COLUMNS_KEY, columns);
  };

  return (
    <ColumnMenu
      columns={mixtureColumns}
      selectedColumns={selectedColumns}
      onColumnsChange={onColumnsChange}
    />
  );
}
